import { OrderReceiptResponse } from "../../common/hooks/console/transaction/usePutReceipt";

/**
 * 인수증 인쇄
 *
 * 본점 콘솔 Transaction.tsx 의 handlePrintReceipt 인쇄 템플릿을 그대로 가져왔다.
 * 콘솔 파일을 건드리지 않으려고 복사한 것이므로, 인수증 서식이 바뀌면 양쪽을 함께 고쳐야 한다.
 *
 * 지점은 판매금액(sales_amount)이 1계층에서 마스킹돼 내려오므로 금액 칸이 비어 출력된다.
 */
export const getBase64Image = (imgUrl: string, callback: (dataUrl: string) => void) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = imgUrl;
    img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx?.drawImage(img, 0, 0);
        callback(canvas.toDataURL("image/png"));
    };
};

export const printReceipt = (data: OrderReceiptResponse[], base64Logo: string) => {
                        const receiptHtml = `
                <html lang="ko">
                    <head>
                        <title>인수증</title>
                        <style>
                        @page { size: A4 landscape; margin: 0; }
                         @media print {
                            .page-break {
                                page-break-after: always;
                            }
                        }
                        body {
                                font-family: Arial, sans-serif;
                                margin: 0;
                                height: 100vh;
                                display: flex;
                                flex-direction: column;
                                align-items: center;    
                                -webkit-print-color-adjust: exact; 
                                print-color-adjust: exact;    
                        }
                        .container {
                                /* border-box 가 아니면 width 98% 에 좌우 padding 이 더해져 오른쪽으로 삐져나간다 */
                                box-sizing: border-box;
                                display: flex;
                                width: 98%;
                                max-height: 95vh;
                                max-width: 1800px;
                                gap: 40px;
                                padding: 35px 20px 0 20px;
                        }
                             .receipt {
                                /* 절단선 기준 좌우 5:5. flex-basis 0 이라 내용 길이와 무관하게 반씩 나눈다 */
                                flex: 1 1 0;
                                min-width: 0;
                                background: white;
                            }
                            .receipt {
                                border-top: 3px solid black;
                                border-left: 3px solid black;
                                border-right: 2px solid black;
                            }
                            .receipt-header {
                                padding: 20px 18px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                border-bottom: 2px solid black;
                                background-color: #dddddd;
                                gap: 20px;
                            }
                            .receipt-header h1 {
                                font-size: 22px;
                                margin: 0;
                            }
                            .receipt-header p {
                                font-size: 20px;
                                font-weight: bold;
                                margin: 0;
                            }
                            .receipt h1 {
                                text-align: left;
                                font-size: 23px;
                            }
                            .receipt-table {
                                width: 100%;
                                border-collapse: collapse;
                                margin-top: 0;
                            }
                            .receipt-table td {
                                padding: 8px;
                                font-size: 18px;
                                border-right: 2px solid black;
                                border-bottom: 2px solid black; 
                            }
                            .receipt-table td:first-child {
                                background-color: #F1F1F1;
                                font-weight: bold;
                                width: 25%;
                                text-align: center;
                                font-size: 15px; 
                                border-bottom: 2px solid black;
                            }
                            .receipt-table td:nth-child(2) {
                                border-left: none;
                                border-right: none;
                                font-size: 15px;
                                font-weight: normal;
                            }
                            .receipt-table tr:nth-child(1) td{
                                height: 78px; 
                            }
                            .receipt-table tr:nth-child(2) td{
                                height: 58px; 
                            }
                            .receipt-table tr:nth-child(3) td{
                                height: 64.3px; 
                            }
                            .receipt-table tr:nth-child(4) td{
                                height: 58px; 
                            }
                            .receipt-table tr:nth-child(5) td {
                                height: 103px; 
                            }
                            .receipt-table tr:nth-child(6) td{
                                height: 58px; 
                            }
                            .receipt-table tr:nth-child(7) td{
                                height: 58px; 
                            }
                            .receipt-table tr:nth-child(8) td{
                                height: 58px; 
                            }
                            .receipt-table tr:nth-child(9) td {
                                height: 83px;
                            }
                           .footer {
                                display: flex;
                                flex-direction: column;
                                align-items: start;
                                text-align: left;
                                position: relative;
                                top: -73px; 
                                left: 310px;
                           }
                           .footer img {
                                width: 130px; 
                                height: auto;
                           }
                          .justify-between {
                                display: flex;
                                justify-content: space-between;
                                width: 100%;
                            }
                             .divider {
                                width: 1px;
                                opacity: 50%;
                                background-color: #999;
                                height: 98%;
                                align-self: center;
                            }
                        </style>
                    </head>
                    <body>
                        ${data
                                .map(receipt => {
                                    function safeText(str: string) {
                                        return str.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/ /g, "&nbsp;");
                                    }
                                    const eventLabel =
                                        receipt.event_content?.depth1 === "직접입력"
                                            ? receipt.event_content?.event_content
                                                ? ` [${receipt.event_content.event_content}]`
                                                : ""
                                            : receipt.event_content?.depth1 === "선택안함"
                                                ? ""
                                                : receipt.event_content?.depth2
                                                    ? ` [${receipt.event_content.depth2}]`
                                                    : "";
                                    // 절단선 좌우에 같은 인수증을 한 장씩 찍는다
                                    const receiptBody = `
                            <div class="receipt">
                                <div class="receipt-header">
                                    <h1>인&nbsp;&nbsp;수&nbsp;&nbsp;증</h1>
                                    <p>${receipt.order_number}</p>
                                </div>
                                <table class="receipt-table">
                                    <tr><td>보&nbsp;&nbsp;&nbsp;낸&nbsp;&nbsp;&nbsp;곳</td><td style="white-space:pre-wrap;">${safeText(receipt.wreath_sender)}</td></tr>
                                    <tr>
                                        <td>종류및금액</td>
                                        <td>
                                            <div>
                                                <div class="justify-between">
                                                    <div>
                                                        <span>${receipt.product_name}</span>
                                                        <span>(${receipt?.product_quantity})</span>
                                                    </div>
                                                    <span>${receipt.order_amount ? receipt.order_amount / 10000 : ""}</span>
                                                </div>
                                                <div style="word-break:break-word;">${receipt.customer_request !== null ? `<div>${receipt.customer_request}</div>` : ""}</div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr><td>내&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;용</td><td>${receipt.wreath_word}</td></tr>
                                    <tr><td>받으시는 분</td><td>  
                                        ${receipt.recipient_name}
                                        ${eventLabel}
                                        ${receipt.related_person ? ` [${receipt.related_person}]` : ""}
                                    </td></tr>
                                    <tr><td>배&nbsp;송&nbsp;주&nbsp;소</td><td>${receipt.delivery_address}<br /> ${receipt.delivery_address_detail}</td></tr>
                                    <tr><td>연&nbsp;&nbsp;&nbsp;락&nbsp;&nbsp;&nbsp;처</td><td>${receipt.recipient_mobile}</td></tr>
                                    <tr><td>배&nbsp;송&nbsp;일&nbsp;시</td><td>${receipt.delivery_date} ${receipt.delivery_time || "없음"}</td></tr>
                                    <tr><td>배&nbsp;송&nbsp;메&nbsp;모</td><td>${receipt.delivery_memo || "없음"}</td></tr>
                                    <tr><td>인&nbsp;&nbsp;&nbsp;수&nbsp;&nbsp;&nbsp;자</td><td style="text-align:right;"><img src="${base64Logo}" alt="Logo" style="width:130px"; /></td></tr>
                                </table>
                            </div>`;

                                    return `
                        <div class="container page-break">
                            ${receiptBody}
                            <div class="divider"></div>
                            ${receiptBody}
                        </div>
                        `;
                                })
                                .join("")}

                        <script>
                            window.onload = function() {
                                window.print();
                                setTimeout(() => window.close(), 0);
                            };
                        </script>
                    </body>
                </html> `;

    const printWindow = window.open("", "_blank", "width=1920,height=1080");
    if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(receiptHtml);
        printWindow.document.close();
    }
};
